import type { PainelTextEntry } from '@/lib/painel-texts';
import { apiGet, apiPut } from './api-client';

export async function getPanelTexts(): Promise<PainelTextEntry[]> {
  try {
    const res = await apiGet<{ data: PainelTextEntry[] }>('/panel-texts');
    return res.data ?? [];
  } catch {
    return [];
  }
}

export async function updatePanelTexts(entries: PainelTextEntry[]): Promise<PainelTextEntry[]> {
  const res = await apiPut<{ data: PainelTextEntry[] }>('/admin/panel-texts', { entries }, true);
  return res.data;
}
